import { Routes } from '@angular/router';
import { ClientComponent } from '../../pages/client/client.component';
import { CustomerSearchComponent } from '../../pages/customer/customer-search/customer-search.component';
import { CertificatesComponent } from '../../pages/certificates/certificates/certificates.component';
import { UserProfileComponent } from '../../pages/user-profile/user-profile.component';
import { UpdatePasswordComponent } from '../../pages/update-password/update-password.component';
import { CustomerManagementListComponent } from 'src/app/pages/customer-management/customer-management-list/customer-management-list.component';



export const ClientLayoutRoutes: Routes = [  
  { path: '', component: ClientComponent, title: 'Client - CVT Web' },
  { path: 'customer', component: CustomerSearchComponent, title: 'Customer Search - CVT Web' },
  { path: 'customer-management', component: CustomerManagementListComponent, title: 'Customer Management - CVT Web' },
  { path: 'certificates', component: CertificatesComponent, title: 'Certificates - CVT Web' },
  { path: 'user-profile', component: UserProfileComponent, title: 'User Profile - CVT Web' },
  { path: 'update-password/:userId', component: UpdatePasswordComponent, title: 'Update Password - CVT Web' }
];
